import React, { useEffect, useState, useRef, } from 'react';
import { Swipeable } from 'react-swipeable';
import { Container, Description, Grid, LeftArrowWrapper, List, RightArrowWrapper, Title, Wrapper, } from './css';
import { LeftArrow, RightArrow } from '../SlidingWidgetV2/css';
import CONSTANTS from './constants';
const ProductV2 = (widgetData) => {
    const { params, children, isDesktop, cssStyle, } = widgetData;
    const { title, description, appBkgColor, } = params;
    const { descriptionStyle, titleStyle, } = cssStyle;
    const [transform, setTransform] = useState(0);
    const [scrollingWidth, setScrollingWidth] = useState(0);
    const [enableArrows, setEnableArrows] = useState(true);
    const listRef = useRef(null);
    const leftArrowClick = () => {
        if (transform < 0) {
            setTransform(transform + CONSTANTS.SCROLL_OFFSET);
        }
    };
    const rightArrowClick = () => {
        if (transform > -scrollingWidth) {
            setTransform(transform - CONSTANTS.SCROLL_OFFSET);
        }
    };
    useEffect(() => {
        const { scrollWidth, clientWidth, offsetWidth } = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        const maxScrollWidth = (scrollWidth - clientWidth);
        setScrollingWidth(maxScrollWidth);
        setEnableArrows(scrollWidth > offsetWidth);
    }, [setEnableArrows, setScrollingWidth]);
    // const childrens = children.map((product) => product);
    return (React.createElement(Grid, { appBkgColor: appBkgColor },
        React.createElement(Wrapper, { isDesktop: isDesktop },
            React.createElement("div", { className: "title-description" },
                title && (React.createElement(Title, { padding: titleStyle.padding, text: titleStyle.text, isDesktop: isDesktop }, title)),
                description && (React.createElement(Description, { padding: descriptionStyle.padding, text: descriptionStyle.text, isDesktop: isDesktop }, description))),
            isDesktop && enableArrows && (React.createElement(LeftArrowWrapper, null,
                React.createElement(LeftArrow, { onClick: leftArrowClick }))),
            React.createElement(Swipeable, { delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: false, trackMouse: false, rotationAngle: 0, style: {
                    height: '90%',
                    position: 'relative',
                } },
                React.createElement(List, { isDesktop: isDesktop, ref: listRef }, isDesktop ? (React.createElement(Container, { transform: transform }, children)) : (children))),
            isDesktop && enableArrows && (React.createElement(RightArrowWrapper, null,
                React.createElement(RightArrow, { onClick: rightArrowClick }))))));
};
export default ProductV2;
